import { useState, useEffect } from 'react';
import { fetchQuarterReportDetails } from '@user-center/services/quarterReport';
import { getQuarterReportDate } from '../utils';

const formatReportDetails = (reportDetails?: IQuarterReportDetails | null): IQuarterReportDetails | null => {
  if (!reportDetails) {
    return null;
  }

  const topVisitedGames = reportDetails.top_visit_game?.filter((game) => !!game?.game_name) || [];
  const favoriteGames = reportDetails.favourite_games?.filter((game) => !!game?.name) || [];

  return {
    ...reportDetails,
    top_visit_game: topVisitedGames,
    favourite_games: favoriteGames,
  };
};

export default function useQuarterReport(props: { date: string; openId?: string }) {
  const { date, openId } = props;

  const [loading, setLoading] = useState(true);
  const [reportDate, setReportDate] = useState('');
  const [report, setReport] = useState<IQuarterReportDetails | null>(null);

  const isNoData = (() => {
    if (loading) {
      return false;
    }

    return report?.pv_ind !== 'Y';
  })();

  const updateReport = async (date: string, openId?: string) => {
    if (!date) {
      console.warn('updateReport方法: date is required!');
      setLoading(false);
      setReportDate('');
      setReport(null);
      return;
    }

    try {
      const res = await fetchQuarterReportDetails({ date, open_id: openId });
      const reportTmp = formatReportDetails(res?.data);
      setReportDate(date);
      setReport(reportTmp || null);
    } catch (error) {
      console.error(error);
      setReportDate('');
      setReport(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const startDateOfQuarter = getQuarterReportDate(date);
    updateReport(startDateOfQuarter, openId);
  }, [date, openId]);

  return { loading, isNoData, reportDate, report };
}
